import { render, staticRenderFns } from "./certificationinfo.vue?vue&type=template&id=d4bad840&scoped=true"
import script from "./certificationinfo.vue?vue&type=script&lang=js"
export * from "./certificationinfo.vue?vue&type=script&lang=js"
import style0 from "./certificationinfo.vue?vue&type=style&index=0&id=d4bad840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bad840",
  null
  
)

export default component.exports